import Icon from 'ui/components/Icon'
import {
  CheckboxWrap,
  CheckboxInput,
  CheckboxCustom,
  CheckboxLabel,
} from './styled'

const Checkbox = ({ label, disabled = false, ...otherProps }) => (
  <CheckboxWrap as={label ? 'label' : 'div'} $disabled={disabled}>
    <CheckboxInput disabled={disabled} {...otherProps} />

    <CheckboxCustom $disabled={disabled}>
      <Icon name="checkbox" />
    </CheckboxCustom>

    {label && <CheckboxLabel $disabled={disabled}>{label}</CheckboxLabel>}
  </CheckboxWrap>
)

export default Checkbox
